<template>
    <span>
        {{ text }}
        <span v-if="required" class="required-mark">*</span>
    </span>
</template>

<script setup lang="ts">
import { toRefs } from 'vue';

const props = defineProps<{
    text: string;
    required?: boolean;
}>();

const { text, required } = toRefs(props);
</script>

<style scoped>
.required-mark {
    color: red !important;
}
</style>
